import React, { useCallback, useRef, useState } from 'react';
import { useLanguage } from '../hooks/useLanguage.js';
import { useOnDismiss } from '../hooks/useOnDismiss';
import { cx } from '../utils/cx';

export function Translator({onChangeLanguage}) {
    const dropdown = useRef(null);

    const [language, setLanguage] = useLanguage();

    const [showDropdown, setShowDropdown] = useState(false);

    useOnDismiss(
        dropdown,
        showDropdown,
        useCallback(
            () => setShowDropdown(false),
            [setShowDropdown],
        ),
    );

    function changeLanguage(lang) {
        setShowDropdown(false);
        setLanguage(lang);

        onChangeLanguage(lang);
    }

    return (
        <div className="relative">
            <button
                className={cx(
                    'inline-flex items-center gap-x-0.5 rounded-full pl-3 pr-2 py-1.5 ml-2 bg-headertext text-header maxxsm:ml-1 w-14',
                    showDropdown && 'rounded-b-none rounded-t',
                )}
                onClick={() => setShowDropdown(!showDropdown)}
            >
                <span
                    className="lang-switcher-button block"
                    translate="no"
                >
                    {language.toUpperCase()}
                </span>
                <i
                    className={cx(
                        'icon-chevron text-[14px]',
                        showDropdown && 'rotate-180',
                    )}
                />
            </button>
            <div
                className={cx(
                    'absolute top-0 right-0 w-14 z-40 pt-7 cursor-pointer',
                    !showDropdown && 'hidden',
                )}
            >
                <div
                    className={cx(
                        'relative z-50',
                    )}
                    ref={dropdown}
                >
                    <div className="flex bg-headertext flex-col items-center justify-center divide-y divide-header/50 rounded-b">
                        <button
                            className="text-header py-3 w-full border-t border-header/50"
                            onClick={() => changeLanguage('se')}
                            translate="no"
                        >
                            SV
                        </button>
                        <button
                            className="text-header py-3 w-full"
                            onClick={() => changeLanguage('en')}
                            translate="no"
                        >
                            EN
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
